import { IIconProps } from "./Icons.types";

export const InSalesLogo = ({
  size,
  width = 96,
  height = 64,
  color = "#2B2D33",
}: IIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 148 45"
      fill="none"
      width={size || width}
      height={size || height}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.769 20.5798C34.0965 18.5624 33.8644 16.4242 34.0883 14.3094C34.3089 12.1944 34.9808 10.1513 36.0586 8.31819C39.9189 1.75187 48.2188 -1.07679 56.0197 0.948499L58.286 4.36488L54.6583 7.22306C47.204 5.2316 39.5088 8.06869 36.2996 13.5103C35.056 15.6462 34.5203 18.1209 34.769 20.5798V20.5798Z"
        fill="#F35C22"
      />
      <path
        d="M0.334961 14.4869C0.347003 13.5358 0.727435 12.6264 1.39623 11.9501C2.06819 11.2703 2.9776 10.8778 3.93312 10.855C4.89862 10.8657 5.82147 11.2542 6.50382 11.9374C7.18697 12.6197 7.57557 13.5426 7.58625 14.5081C7.56745 15.4628 7.17769 16.3727 6.49959 17.045C5.81478 17.7182 4.89341 18.0962 3.93312 18.0978C2.98085 18.0873 2.07042 17.7049 1.39623 17.0323C0.723135 16.3553 0.342135 15.4416 0.334961 14.4869V14.4869ZM1.01992 20.8292H6.90971V43.6612H1.01992V20.8292Z"
        fill={color}
      />
      <path
        d="M33.4581 29.6405V43.6611H27.5641V30.372C27.5641 27.2685 25.6952 25.6703 23.0442 25.6703C20.169 25.6703 18.0211 27.3615 18.0211 31.3318V43.6611H12.1313V20.829H18.0211V23.3659C19.3911 21.3111 21.7673 20.1694 24.8242 20.1694C29.695 20.1906 33.4581 23.5689 33.4581 29.6405Z"
        fill={color}
      />
      <path
        d="M37.0015 36.4013L42.3924 33.2471C43.534 36.2068 45.7749 38.1349 49.7409 38.1349C53.5462 38.1349 54.8569 36.5366 54.8569 34.7524C54.8569 32.3761 52.7091 31.4629 47.9608 30.1014C43.0773 28.685 38.3249 26.63 38.3249 20.5584C38.3249 14.4868 43.3479 11.062 48.8276 11.062C54.0789 11.062 58.0999 13.7553 60.2436 18.2499L54.9499 21.311C53.8083 18.8883 52.0706 17.2013 48.8276 17.2013C46.1808 17.2013 44.6291 18.5712 44.6291 20.3978C44.6291 22.3596 45.8594 23.4125 50.7007 24.8712C55.7745 26.4694 61.1611 28.1607 61.1611 34.6889C61.1611 40.6718 56.3621 44.3248 49.559 44.3248C43.0308 44.2995 38.7392 41.158 37.0015 36.4013Z"
        fill={color}
      />
      <path
        d="M88.7414 20.8289V43.6609H82.8474V40.9676C81.2068 43.0225 78.7376 44.2994 75.4058 44.2994C69.3299 44.2994 64.3069 39.048 64.3069 32.2449C64.3069 25.4418 69.3299 20.1904 75.4058 20.1904C78.7376 20.1904 81.2068 21.4589 82.8474 23.5222V20.8289H88.7414ZM82.8474 32.2449C82.8474 28.41 80.154 25.8054 76.5051 25.8054C72.8562 25.8054 70.2052 28.41 70.2052 32.2449C70.2052 36.0798 72.8985 38.6844 76.5051 38.6844C80.1117 38.6844 82.8474 36.0841 82.8474 32.2449Z"
        fill={color}
      />
      <path
        d="M93.9207 10.3267H99.8401V43.6614H93.9207V10.3267Z"
        fill={color}
      />
      <path
        d="M116.503 38.955C118.787 38.955 120.613 37.9994 121.615 36.6718L126.368 39.4116C124.22 42.5193 120.795 44.2994 116.41 44.2994C108.74 44.2994 103.899 39.048 103.899 32.2449C103.899 25.4418 108.783 20.1904 115.954 20.1904C122.719 20.1904 127.509 25.5306 127.509 32.2449C127.505 33.0563 127.429 33.8656 127.281 34.6634H110.064C110.884 37.6781 113.37 38.955 116.503 38.955ZM121.615 30.0758C120.888 26.7906 118.419 25.4629 115.954 25.4629C112.804 25.4629 110.656 27.1542 109.971 30.0758H121.615Z"
        fill={color}
      />
      <path
        d="M147.783 36.9933C147.783 41.9233 143.491 44.2995 138.604 44.2995C134.037 44.2995 130.659 42.3799 129.014 38.8663L134.13 35.9869C134.769 37.86 136.32 38.9467 138.604 38.9467C140.477 38.9467 141.754 38.3082 141.754 36.9848C141.754 33.653 129.974 35.4796 129.974 27.4419C129.974 22.7909 133.944 20.1821 138.65 20.1821C142.35 20.1821 145.546 21.8734 147.326 25.0192L142.303 27.759C141.995 27.0519 141.482 26.4527 140.832 26.0381C140.181 25.6235 139.421 25.413 138.65 25.4335C137.187 25.4335 135.999 26.072 135.999 27.3024C135.999 30.6933 147.783 28.5919 147.783 36.9933Z"
        fill={color}
      />
    </svg>
  );
};
